var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHidePasswordEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_539",
    "data-name": "Rectangle 539",
    width: 18,
    height: 18,
    transform: "translate(287 21)",
    fill: "#00b4a4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Show_Password_Toggle",
    "data-name": "Show Password Toggle",
    transform: "translate(-287 -21)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(287 21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M17.886,8.65C17.725,8.43,13.893,3.264,9,3.264S.275,8.43.114,8.65a.594.594,0,0,0,0,.7C.275,9.57,4.106,14.736,9,14.736S17.725,9.57,17.886,9.35A.593.593,0,0,0,17.886,8.65ZM9,13.549c-3.6,0-6.726-3.429-7.651-4.55C2.272,7.878,5.388,4.451,9,4.451S15.726,7.879,16.651,9C15.728,10.122,12.612,13.549,9,13.549Z",
    fill: "#00b4a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M9,5.44A3.56,3.56,0,1,0,12.56,9,3.565,3.565,0,0,0,9,5.44Zm0,5.934A2.374,2.374,0,1,1,11.374,9,2.376,2.376,0,0,1,9,11.374Z",
    fill: "#00b4a4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordEyeIcon);
export default __webpack_public_path__ + "static/media/hide-password-eye-icon.6f652e48d7d09c03e6ec14da77d4e477.svg";
export { ForwardRef as ReactComponent };